import { get, del, jsonPost } from '@client/lib/request';
import { FlashMessage } from '@pegasus/ui-flashmessages';

export const getFlashMessages = () =>
    get('/api/flash-messenger/clients/me/messages')
        .then(data => {
            if (data?.results?.length) {
                del('/api/flash-messenger/clients/me/messages');
            }

            return data?.results || [];
        })
        .catch(() => []);

export const createFlashMessage = (message: FlashMessage) =>
    jsonPost('/api/flash-messenger/clients/me/messages', message, null);
